import axios from "axios";
import { notification } from "antd";
import authAction from "../auth/actions";
import appAction from "../app/actions";
import { setLogoutModalVisibility } from "../auth/actions";
import { store } from "../store";
//import { clearFormData } from '../redux/CompanyMaster/actions'; // Import your logout action

const { logout } = authAction;
const { closeAll } = appAction;
const axiosInstance = axios.create({
  timeout: 30000, // 30 seconds timeout
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get token from localStorage or your auth state
    const token = localStorage.getItem("access_token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.method.toUpperCase() === "OPTIONS") {
      return Promise.reject(
        new Error("Client-side use of HTTP OPTIONS is disallowed.")
      );
    }

    // Add transaction ID or other common headers
    config.headers.transactionId = "1";

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Handle 401 Unauthorized error
    if (error.response.status === 401 && !originalRequest._retry) {
      // Show logout modal
      store.dispatch(setLogoutModalVisibility(true));

      try {
        // Attempt to refresh token
        const refreshToken = localStorage.getItem("refresh_token");
        if (refreshToken) {
          const response = await axios.post("/api/refresh-token", {
            refreshToken,
          });
          const newToken = response.data.access_token;

          // Save new token
          localStorage.setItem("access_token", newToken);

          // Update authorization header
          originalRequest.headers.Authorization = `Bearer ${newToken}`;

          // store.dispatch(setLogoutModalVisibility(true));

          // Retry original request
          return axiosInstance(originalRequest);
        }
      } catch (refreshError) {
        // If refresh token fails, logout user
        handleLogout();
      }
    }

    // Handle other errors
    handleError(error);
    return Promise.reject(error);
  }
);

// Error handler function
const handleError = (error) => {
  let errorMessage = "An error occurred";

  if (error.response) {
    switch (error.response.status) {
      case 400:
        errorMessage = "Bad Request";
        break;
      case 401:
        errorMessage = "Unauthorized";
        //handleLogout();
        break;
      case 403:
        errorMessage = "Forbidden";
        break;
      case 404:
        errorMessage = "Not Found";
        break;
      case 500:
        errorMessage = "Internal Server Error";
        break;
      default:
        errorMessage = "Something went wrong";
    }
  } else if (error.request) {
    errorMessage = "No response received from server";
  }

  // notification.error({
  //   message: 'Error',
  //   description: errorMessage,
  // });
};

// Logout handler
const handleLogout = async () => {
  sessionStorage.removeItem("remainingTime");
  sessionStorage.removeItem("sessionTimeout");
  logout();
  closeAll();

  // Dispatch logout action
  //   if (window.store) {
  //     window.store.dispatch(clearFormData());
  //   }
  // Dispatch logout actions
  store.dispatch(setLogoutModalVisibility(true));

  // Redirect to login
  // window.location.href = '/login';
};

export default axiosInstance;
